import React, { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import { Contracts } from '@components/Home/Contracts/Contracts';
import { IntroTasks } from '@components/Home/IntroTasks/IntroTasks.tsx';
import { IntroContext } from '@components/Intro/Intro.tsx';
import { Navigation } from '@components/Navigation/Navigation';
import { PageBackground } from '@components/ui/Backgrounds/PageBackground/PageBackground';
import { type RootState } from '@redux/store';

import { useGetPartnersTaskQuery } from '@/api/queries/user';
import { useCheckVIPstatus } from '@/common/hooks/checkVIPstatus';
import ChangeGroup from '@/components/Friends/TabsBody/ChangeGroup/ChangeGroup';
import { ExtraNavigation } from '@/components/Home/ExtraNavigation/ExtraNavigation';
import { RequestsAndModalsLogic } from '@/components/Home/RequestsAndModalsLogic/RequestsAndModalsLogic';

import Default from './Default';
import Vip from './VIP';

import backgroundChangeGroupPng from '/img/bg/friends-page.png';
import backgroundChangeGroupWebp from '/img/bg/friends-page.webp';

const Home: React.FC = () => {
  const changeGroup = useSelector(
    (state: RootState) => state.user.user?.changeGroup,
  );
  const statusVIP = useCheckVIPstatus();
  const { finishIntroPlants } = useContext(IntroContext);
  useGetPartnersTaskQuery();

  useEffect(() => {
    Telegram.WebApp.BackButton.hide();
  }, []);

  return (
    <>
      <RequestsAndModalsLogic />
      {changeGroup ? (
        <main className="page !mb-0">
          <PageBackground
            className="sm-h:h-[40vh] md-h:h-[43vh]"
            variant="page"
            backgroundImage={{
              png: backgroundChangeGroupPng,
              webp: backgroundChangeGroupWebp,
            }}
          />
          <div className="tabs tabs--sticky" style={{ padding: '0 16px' }}>
            <ChangeGroup />
          </div>
        </main>
      ) : (
        <main className="w-full h-full flex flex-col">
          <Helmet>
            <title>Office</title>
          </Helmet>
          {statusVIP ? <Vip /> : <Default />}
          <Navigation />
          <div className="page-Task-Contracts">
            {finishIntroPlants ? (
              <>
                <ExtraNavigation />
                <Contracts />
              </>
            ) : (
              <IntroTasks />
            )}
          </div>
        </main>
      )}
    </>
  );
};

export default Home;
